import { authLoginError, authLoginSuccess } from '@store/slices/auth/authSlice.js';
import { getFormBodyEncoded, logoutClearStore } from '@utils/functions';
import httpClientLogin from '@utils/httpClientLogin';
import { setToken, setUser } from '@utils/tokenStorage';
import { call, put } from 'redux-saga/effects';

function loginApiCall({ email, password, isGoogle = false, isFacebook = false, isTelegram = false, isTikTok = false }) {
  return httpClientLogin.post(
    `token`,
    getFormBodyEncoded({
      Username: email,
      Password: password,
      grant_type: 'password',
      ...(isGoogle && { google: true }),
      ...(isFacebook && { facebook: true }),
      ...(isTelegram && { telegram: true }),
      ...(isTikTok && { tiktok: true }),
    }),
  );
}

export function* loginRequestSaga({ payload }) {
  const { email, password, isGoogle = false, isFacebook = false, isTelegram = false, isTikTok = false } = payload;
  try {
    const { data: loginData } = yield call(loginApiCall, { email, password, isGoogle, isFacebook, isTelegram, isTikTok });

    const token = loginData.access_token;
    const user = loginData.userName;

    setToken(token);
    setUser(user);

    yield put(authLoginSuccess({ token, email: user }));
  } catch (error) {
    yield put(authLoginError(error?.response?.data?.error_description ? error?.response?.data?.error_description : error?.toString()));

    logoutClearStore();
  }
}
